import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSelfUser, getShops } from "../../../../../services/auth/actions";
import Status from "../../../layouts/dashboard/status";
import { useHistory, useLocation } from "react-router-dom";
import { Spin2, Button } from "components";
import MobileNav from "../mobile-nav";
import useMobile from "../../../../../hooks/useMobile";
import ClosePage from "../../../screens/products/product/screens/components/save-close";

import "./style.scss";


const CloseIcon = () => <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.5 4.5L4.5 13.5" stroke="var(--black9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.5 4.5L13.5 13.5" stroke="var(--black9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;
const Close = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18" stroke="var(--black9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 6L18 18" stroke="var(--black9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;


const Header = ({formRef}) => {

    const [closeConfirmModal, setShowConfirmModal] = useState(false);
    const { pathname } = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const isAuth = useSelector(({auth}) => auth.isAuth);

    const handleSubmit = () => {
        if (formRef.current) {
            formRef.current.handleSubmit()
        }
    }

    useEffect(() => {
        let isAdmin = window.location.origin.includes('admin');

        if (!isAuth) {
            dispatch(getSelfUser())
                .then(({status, data}) => {
                    if (status === 200) {
                        dispatch(getShops(data.user.username));

                        if (isAdmin && +data.user.rank < 1) {
                            history.push(`/home`);
                        }
                    }
                });
        }
    }, []);

    const isManager = pathname.includes('/settings/shop/managers');
    const isPayment = pathname.includes('/settings/shop/payments');
    const isGatewayFees = pathname.includes('/settings/shop/gateway-fees');
    const isMobile = useMobile();
    const onGoBack = () => {
        history.push('/');
    };

    return <>
        <Status/>
        <div className="settings-header-container">
            <div className="settings-header">
                {isMobile ? <div onClick={onGoBack} className="settings-header-close"><Close/></div> : null}

                <div className="settings-header-logo"  style={{ color: "var(--black9)" }}>Settings</div>

                <div className="settings-header-buttons">
                    <div className="settings-header-menu">
                        {(isManager || isGatewayFees)
                            ? null
                            : <Button size="large" id="submit-settings" className={isPayment ? "d-flex" : ""} onClick={handleSubmit}>
                                <span className="submit-button-text">Save Changes</span> <span className="submit-button-loader d-none"><Spin2 /></span>
                            </Button>
                        }

                        {isMobile ? null :
                            <Button size="large" style={{ marginRight: ".75rem" }} variant="secondary" onClick={() => {
                                if(formRef && formRef.current && formRef.current.dirty) {
                                    setShowConfirmModal(true);
                                } else {
                                    history.push('/');
                                }
                            }}>
                                <CloseIcon/>
                            </Button>
                        }
                    </div>
                </div>

                <ClosePage to="/" open={closeConfirmModal} close={() => setShowConfirmModal(false)} />
            </div>
            <MobileNav />
        </div>
    </>
};

export default Header;
